import '../../../../themes/global.scss';

import { motion } from 'framer-motion';
import { useSelector } from 'react-redux';
import browserHistory from '~/history';
import { useCanPostShifts } from '~/hooks';
import { FilterStatusEnum } from '~/utils/Enum';
import CustomSpinner from '../../../../commonComponents/CustomSpinner';
import { EmptyScreen } from '../../../../commonComponents/EmptyScreen/EmptyScreen';
import { getEmptyFilteredScreen, onCardClick } from '../../utils';
import { JobCard } from '../JobCard/JobCard';
import { useJobList } from './useJobList';

export const JobList = ({ status }) => {
  const { jobList, isLoadingList, jobListScrollRef, handleScrollJobList } = useJobList({ status });
  const { actionRequired } = useSelector((state) => state.job.dashboardInfo) || {};
  const canPostShifts = useCanPostShifts();

  if (jobList?.length === 0 && !isLoadingList) {
    const { Icon, title, description, buttonText, buttonLink } = getEmptyFilteredScreen(status);

    const emptyScreenProps = {
      Icon,
      title,
      description,
      buttonText,
      ...(canPostShifts && (status !== FilterStatusEnum.SCHEDULED || actionRequired)
        ? { onButtonClick: () => browserHistory.push(buttonLink) }
        : {}),
    };

    return (
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
        style={{
          height: 750,
        }}
      >
        <EmptyScreen {...emptyScreenProps} />
      </motion.div>
    );
  }

  return (
    <div className="job_list" style={{ height: '100%', width: '100%' }}>
      <div
        ref={jobListScrollRef}
        onScroll={handleScrollJobList}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
          overflowY: 'auto',
          alignItems: 'center',
          height: 750,
          padding: 20,
        }}
      >
        {jobList?.map((job) => (
          <JobCard key={job.id} onCardClick={onCardClick} job={job} />
        ))}
        {isLoadingList && <CustomSpinner style={{ margin: '40px 0' }} isLoading={isLoadingList} />}
      </div>
    </div>
  );
};
